export const USER_DEVICE_SLICE_NAME = 'gygUserDevices'
export const GET_USER_DEVICES_BY_USER_ID_ACTION = `${USER_DEVICE_SLICE_NAME}/getUserDevicesByUserId`
